import React from "react";
import { useNavigate } from "react-router-dom";

function PreviousSession({ session }) {
  const navigate = useNavigate();
  return (
    <button className="cr_session_chip" onClick={() => navigate(`/admin/faculty/error/students/sessions/${session}`)}>
      {session}
    </button>
  );
}

export default PreviousSession;
